module.exports = __webpack_public_path__ + "gift.svg?2b3c567724847b1799f58e876be541d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/gift.svg
// module id = 148
// module chunks = 0